const initializedElements = new WeakSet();

export const initializeTruncatedTooltips = root => {
    root.querySelectorAll('[data-tooltip-when-truncated]').forEach(element => {
        if (initializedElements.has(element)) {
            return;
        }

        initializedElements.add(element);

        if (element.scrollWidth > element.clientWidth) {
            element.dataset.tippyContent = element.textContent.trim();
        }
    });
};
